<script>
    import { fly } from "svelte/transition";
    import { Skeleton } from "../index";
</script>

<div class="example" transition:fly={{ x: 200 }}>
    <h4 class="example-title">基础用法</h4>
    <div class="example-body" style:background={"white"}>
        <Skeleton type="title" />
        <Skeleton lineCount={2} />
    </div>
    <h4 class="example-title">有动画的骨架屏</h4>
    <div class="example-body" style:background={"white"}>
        <Skeleton type="title" animated />
        <Skeleton animated lineCount={2} />
    </div>
    <h4 class="example-title">自定义</h4>
    <div class="example-body" style:background={"white"}>
        <Skeleton
            type="title"
            --height="160px"
            --border-radius="80px"
            animated
        />
    </div>
</div>

<style lang="less">
    @import "./example.less";
</style>
